/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable max-len */
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./Carriage.scss";
import Input from "../../../Common/components/Inputs/Input/Input";
import Seperator from "../Seperator/Seperator";
import TrianglePointer from "../../../Common/components/Icons/TrianglePointer/TrianglePointer";
import t from "../../../Common/utils/translation/translator";
import {
  selectMechanics,
  setAxisOptions,
  setAxisSelection,
  setMechanics,
  setSelectedMechanicsField
} from "../../store/slices/cartesian";
import { AXIS_ANGLE_FIELD, STROKE_LENGTH_FIELD } from "../../../Common/utils/api/common";
import {
  CARRIAGE_ORIENTATIONS,
  DEFAULT_AXIS_OPTIONS,
  DEFAULT_AXIS_SELECTION,
  getMaxOrientationAngle,
  getMinOrientationAngle
} from "../../store/data/cartesianData";

const AXIS_ANGLE = "axisAngle";
const DOUBLE_AXIS_CHOICE = "doubleAxisChoice";
const DOUBLE_AXIS_DISTANCE = "doubleAxisDistance";
const STROKE_LENGTH = "strokeLength";
// TODO: define "betwwen", "center" and "outside" from constants

const DoubleAxisChoiceSectionElem = ({ id, doubleAxisChoice, handleDoubleAxisChoiceChange, title, ...props }) => (
  <>
    <div className="DoubleAxisChoiceSectionElem flex-item-double-axis carriage-typography" {...props}>
      <input
        type="radio"
        name={DOUBLE_AXIS_CHOICE}
        id={id}
        checked={doubleAxisChoice === id}
        onChange={(event) => handleDoubleAxisChoiceChange(event)}
      />
      <span className="ml-1">
        {title}
        <span className="light-error-active">*</span>
      </span>
    </div>
  </>
);

const DoubleAxisChoiceSection = ({ doubleAxisChoice, handleDoubleAxisChoiceChange, ...props }) => (
  <div className="DoubleAxisChoiceSection" {...props}>
    <TrianglePointer data-testid="triangle-pointer-parameter-section" />
    <div
      className="flex-container-double-axis py-4"
      style={{
        marginTop: "0px"
      }}
    >
      <DoubleAxisChoiceSectionElem
        data-testid="double-axis-choice-section-elem-between"
        id="between"
        title={t("cartesian.ui.mechanics.double_axis_choice_between")}
        doubleAxisChoice={doubleAxisChoice}
        handleDoubleAxisChoiceChange={handleDoubleAxisChoiceChange}
      />
      <DoubleAxisChoiceSectionElem
        data-testid="double-axis-choice-section-elem-center"
        id="center"
        title={t("cartesian.ui.mechanics.double_axis_choice_center")}
        doubleAxisChoice={doubleAxisChoice}
        handleDoubleAxisChoiceChange={handleDoubleAxisChoiceChange}
      />
      <DoubleAxisChoiceSectionElem
        data-testid="double-axis-choice-section-elem-outside"
        id="outside"
        title={t("cartesian.ui.mechanics.double_axis_choice_outside")}
        doubleAxisChoice={doubleAxisChoice}
        handleDoubleAxisChoiceChange={handleDoubleAxisChoiceChange}
      />
    </div>
  </div>
);

const InputSection = ({
  value,
  handleChange,
  subtitle,
  label,
  name,
  unit,
  min,
  max,
  labelRequired,
  minMaxTopLabelShow,
  isInvalid,
  onfocusin,
  onfocusout,
  invalidText,
  ...props
}) => (
  <div className="InputSection grid-item-input" {...props}>
    <div className="flex-1 grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1  gap-1 ">
      <Input
        data-testid={`input-${name}`}
        type="number"
        pattern="^\d+(\.\d{1,2})?$"
        autoComplete="off"
        required
        value={value}
        name={name}
        label={label}
        unit={unit}
        classes="carriage-typography"
        onChange={handleChange}
        placeHolder="-"
        labelRequired={labelRequired}
        inputClasses="hide-arrow"
        unitClasses="input_unit"
        min={min}
        max={max}
        minMaxTopLabelShow={minMaxTopLabelShow}
        invalidText={invalidText || t("msizer.ui.mandatory_field_missing")}
        isInvalid={isInvalid}
        onfocusin={onfocusin}
        onfocusout={onfocusout}
      />
      <div className="carriage-typography-choose">{subtitle}</div>
    </div>
  </div>
);

const CarriageParametersSection = ({ validateStrokeLength, ...props }) => {
  const dispatch = useDispatch();
  const mechanics = useSelector(selectMechanics);

  const handleInputChange = (event) => {
    const { name, id } = event.target;
    let { value } = event.target;
    if (name === STROKE_LENGTH && value < 0) {
      return;
    }

    if (name === AXIS_ANGLE || name === STROKE_LENGTH) {
      value = parseInt(value);
      event.target.value = value;
    }

    const newData = {
      ...mechanics,
      [name]: name === DOUBLE_AXIS_CHOICE ? id : value
    };

    const isStrokeLengthChanged = newData.strokeLength !== mechanics.strokeLength;
    dispatch(setMechanics(newData));
  };

  const getFocusText = (name) => {
    switch (name) {
      case STROKE_LENGTH:
        return STROKE_LENGTH_FIELD;
      case AXIS_ANGLE:
        return AXIS_ANGLE_FIELD;
      default:
        return "";
    }
  };

  const handleInputFocusIn = (event) => {
    const { name } = event.target;
    dispatch(setSelectedMechanicsField(getFocusText(name)));
  };

  const handleInputFocusOut = () => {
    /* const newData = {
      ...mechanics,
      selectedField: ""
    };
    dispatch(setMechanics(newData));
    */
  };
  const maxAngle = getMaxOrientationAngle(mechanics.carriageOrientation);
  const minAngle = getMinOrientationAngle(mechanics.carriageOrientation);
  return (
    <div className="CarriageParametersSection my-5 space-y-5" {...props}>
      <div className="flex space-x-5 items-start">
        <InputSection
          data-testid={`input-section-${STROKE_LENGTH}`}
          value={mechanics.strokeLength}
          handleChange={handleInputChange}
          subtitle={t("cartesian.ui.mechanics.stroke_length_subtitle")}
          name={STROKE_LENGTH}
          label={t("cartesian.ui.mechanics.stroke_length")}
          unit="mm"
          labelRequired
          isInvalid={validateStrokeLength}
          onfocusin={handleInputFocusIn}
          onfocusout={handleInputFocusOut}
          max={5900}
          minMaxTopLabelShow={false}
          invalidText={t("cartesian.ui.mechanics.stroke_length.invalid")}
        />
        <InputSection
          data-testid={`input-section-${AXIS_ANGLE}`}
          value={mechanics.axisAngle}
          handleChange={handleInputChange}
          subtitle={
            t("cartesian.ui.mechanics.axis_angle_subtitle.firstpart") +
            " " +
            minAngle +
            "° " +
            t("cartesian.ui.mechanics.axis_angle_subtitle.secondpart") +
            " " +
            maxAngle +
            "°"
          }
          name={AXIS_ANGLE}
          label={t("cartesian.ui.mechanics.axis_angle")}
          unit="°"
          min={minAngle}
          max={maxAngle}
          labelRequired
          minMaxTopLabelShow={false}
          isInvalid={mechanics.axisAngle === ""}
          onfocusin={handleInputFocusIn}
          onfocusout={handleInputFocusOut}
        />
      </div>
      {false && (
        <>
          <Seperator />
          <div className="flex space-x-5">
            <InputSection
              data-testid={`input-section-${DOUBLE_AXIS_DISTANCE}`}
              value={mechanics.doubleAxisDistance}
              handleChange={handleInputChange}
              name={DOUBLE_AXIS_DISTANCE}
              label={t("cartesian.ui.mechanics.double_axis_distance")}
              unit="mm"
            />
            <div className="flex-1" />
          </div>
        </>
      )}
      {mechanics.doubleAxisDistance ? (
        <DoubleAxisChoiceSection
          data-testid="double-axis-choice-section"
          doubleAxisChoice={mechanics.doubleAxisChoice}
          handleDoubleAxisChoiceChange={handleInputChange}
        />
      ) : null}
    </div>
  );
};
export default CarriageParametersSection;
